/* Magic in my Marks - sticky buy bar */
(function () {
  var bar = document.getElementById('mim-sticky-buy');
  if (!bar) return;
  var addBtn = document.getElementById('mim-sticky-add');
  var buySection = document.getElementById('mim-buy');

  function onScroll() {
    var show = window.scrollY > 600;
    if (buySection) {
      var r = buySection.getBoundingClientRect();
      var inBuy = r.top < window.innerHeight && r.bottom > 120;
      show = show && !inBuy;
    }
    bar.classList.toggle('show', show);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (typeof window.mimAddStandard === 'function') {
        window.mimAddStandard();
      } else {
        var target = document.getElementById('mim-buy');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
})();